export enum SSMLTag {
  // block tags
  AUDIO = 'audio',
  VOICE = 'voice',

  // inline tags
  BREAK = 'break',
  CONVERT = 'resemble:convert',

  // text tags
  EMPHASIS = 'emphasis',
  PHONEME = 'phoneme',
  PROSODY = 'prosody',
  SAY_AS = 'say-as',
  EMOTION = 'resemble:emotion',
  STYLE = 'resemble:style',
  SUB = 'sub',
  TOKEN = 'token',
  LANGUAGE = 'lang',
  FILL = 'resemble:fill',

  // no-op tags
  SUGGESTION = 'resemble:suggestion',
}
